// IE 2026 10 23 / ODOO-5800 (заказ Игоря, скрин 1: «добавь в ячейках под колонкой Сегмент ярлыки, по которым мы провалимся в виджет списка этой
// ссылки (сегмента)»): вкладка Sources карточки DS (AttrGrid name = source_segments, колонка segment) — рядом со значением ярлык-кнопка,
// клик по которой открывает виджет списка (widget-list) этого сегмента, как команда «Open source segment» меню виджета — но для сегмента СТРОКИ.
// Модуль без импортов и без DOM — его логику проверяет tests/unit/segLinkCell.test.mjs: node --test 'tests/unit/segLinkCell*.test.mjs'
// (AttrGrid: segLinkCell_render — вставка ярлыка на обоих путях formatItem, onOpenSegmentList__Click — клик по id ярлыка).

export const SEG_LINK_ID = 'onOpenSegmentList__Click'
export const SEG_LINK_CLASS = 'seg-list-link'
export const SEG_LINK_CELL_CLASS = 'seg-link-cell'   // IE 2026 10 24 / ODOO-348700 (заказ Игоря: ярлык не пропадает при вводе, текст на месте): класс ЯЧЕЙКИ с ярлыком — padding-left под ярлык

// грид — табличная часть источников DS (name / binding source_segments)
export function segLinkCell_grid(gridAttr) {
    if (!gridAttr || typeof gridAttr !== 'object') return false
    const name = String(gridAttr.name || '')
    const binding = String(gridAttr.binding || '')
    return name === 'source_segments' || binding === 'source_segments' || binding.endsWith('.source_segments')
}

// ярлык нужен: колонка segment грида источников со строковым id сегмента (не формула «=», не маркер «#», не шаблон «{»)
export function segLinkCell_on(gridAttr, attr_col, value) {
    if (!segLinkCell_grid(gridAttr) || !attr_col || attr_col.binding !== 'segment') return false
    return !!segLinkCell_segment({ segment: value })
}

// id сегмента строки (значение-словарь {value} — как у AttrMulti) или ''
export function segLinkCell_segment(dataItem) {
    let v = dataItem ? dataItem.segment : null
    if (v && typeof v === 'object') v = v.value
    if (typeof v !== 'string') return ''
    const s = v.trim()
    if (!s || s.startsWith('=') || s.startsWith('#') || s.startsWith('{')) return ''
    return s
}

function esc(s) {
    return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

// разметка ярлыка: кнопка в стиле кнопок ячеек AttrLink (tplBtn.AttrDoc_open), id — ключ ветки клика AttrGrid
export function segLinkCell_html(label) {
    const l = esc(label)
    return `<span wj-part="btn" class="wj-input-group-btn ${SEG_LINK_CLASS}" title="${l}">` +
        `<button class="wj-btn wj-btn-default attr-doc-button my-text-shadow" id="${SEG_LINK_ID}" tabindex="-1" type="button" aria-label="${l}">` +
        `<i class="pi pi-doc pi-folder-open" id="${SEG_LINK_ID}"></i></button></span>`   // IE 2026 10 23 / ODOO-348700 (заказ Игоря: иконка — открывающаяся папка, слева от названия сегмента)
}

// widget_init виджета списка сегмента — как open_widgetList_forAttr (mainStore), без record_id
export function segLinkCell_widgetInit(segment) {
    const s = segLinkCell_segment({ segment })
    if (!s) return null
    return {
        widget: 'widget-list',
        parentAction: { action_name: 'action-front-2026-10-23-1', method: SEG_LINK_ID, tooltip: 'Open the segment list' },
        props: {},
        fieldsMapping: [{ attr: { binding: 'doc.params.segment', value: s } }],
    }
}
